import React from 'react';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import PlaceOrder from '../components/PlaceOrder';
import useCart from '../hooks/useCart';
import useCheckout from '../hooks/useCheckout';
import styles from '../styles/PlaceOrderPage.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const formatPrice = value => `${value.toFixed(2).replace('.', ',')} €`;

const PlaceOrderPage = () => {
  const { items, total } = useCart();
  const { startCheckout, isCheckingOut, checkoutError } = useCheckout();

  const handleSubmit = async customer => {
    if (items.length === 0 || isCheckingOut) return;

    try {
      await startCheckout(items, customer);
    } catch (error) {
      // The checkout hook exposes the error to the form.
    }
  };

  return (
    <DocumentMeta
      title="Place order | Grain Bites"
      description="Enter your details to place a Grain Bites bread and pastry order."
    >
      <main className={styles.page}>
        <header className={styles.hero}>
          <p className={styles.eyebrow}>Grain Bites shop</p>
          <h1>Place your order</h1>
          <p>Your products are ready. Add your details and continue to secure checkout.</p>
        </header>

        <section className={styles.content}>
          {items.length === 0 ? (
            <div className={styles.empty}>
              <h2>Your cart is empty</h2>
              <p>Choose some fresh bread or pastries before placing an order.</p>
              <Link className={styles.button} to={`${publicUrl}/Shop`}>
                Browse the shop
              </Link>
            </div>
          ) : (
            <div className={styles.layout}>
              <PlaceOrder
                onSubmit={handleSubmit}
                isSubmitting={isCheckingOut}
                error={checkoutError}
              />

              <aside className={styles.summary} aria-labelledby="order-summary-title">
                <p className={styles.label}>Your selection</p>
                <h2 id="order-summary-title">Order summary</h2>
                <ul>
                  {items.map(item => (
                    <li key={item.id}>
                      <span>{item.name} × {item.quantity}</span>
                      <strong>{formatPrice(item.price * item.quantity)}</strong>
                    </li>
                  ))}
                </ul>
                <div className={styles.total}>
                  <span>Total</span>
                  <strong>{formatPrice(total)}</strong>
                </div>
                <Link className={styles.back} to={`${publicUrl}/Cart`}>
                  Edit cart
                </Link>
              </aside>
            </div>
          )}
        </section>
      </main>
    </DocumentMeta>
  );
};

export default PlaceOrderPage;
